module.exports = __webpack_public_path__ + "img/petronas-gmap2.92cbe797.png";